export default __webpack_public_path__ + "static/media/Wine-red.b06c3e40.png";